import config from "../config/config.json";
import { headers } from "./../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const studyManagementServices = {
  getStudyManagement,
  addNewStudyManagement,
  updateStudyManagement,
  softDeleteRestoreStudy,
  deleteStudyManagement
};

// Add New Study
async function addNewStudyManagement(userData) {
  const response = await fetch(
    `${config.API_URL}addNewStudyManagement`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data)
  return data;
}

// Update Study
async function updateStudyManagement(userData) {
  const response = await fetch(
    `${config.API_URL}updateStudyManagement`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data)
  return data
}

// Update Study
async function softDeleteRestoreStudy(userData) {
  const response = await fetch(
    `${config.API_URL}softDeleteRestoreStudy`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data)
  return data
}

// Delete Study
async function deleteStudyManagement(userData) {
  const response = await fetch(
    `${config.API_URL}deleteStudyManagement`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data)
  return data
}

// Get Study
async function getStudyManagement(status = "all", searchData = "", page, length) {
  const query = new URLSearchParams();
  query.append("search", searchData || "");

  if (page && length) {
    query.append("page", page);
    query.append("length", length);
  }

  const response = await fetch(
    `${config.API_URL}getStudyManagement/${status || "all"}?${query.toString()}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}